import APIGateway from '@/api';
import { ModelInfoDetail } from '@/types/model';

const delay = ( ms: number ) => new Promise( resolve => setTimeout( resolve, ms ) );

/**
 * Poll LiteLLM until a model is available by name or UUID.
 * Used as a safety net after model creation/update to handle LiteLLM's
 * eventual consistency before invoking or viewing model details.
 */
export async function pollModelReady(
  modelIdentifier: string,
  { maxAttempts = 5, delayMs = 1000 }: { maxAttempts?: number; delayMs?: number } = {}
): Promise<boolean> {
  for ( let attempt = 0; attempt < maxAttempts; attempt++ ) {
    try {
      const res = await APIGateway.models.modelGetInfo();

      const found = res.data?.some(
        ( model: ModelInfoDetail ) => model.model_name === modelIdentifier ||
          model.model_info?.id === modelIdentifier
      );

      if ( found ) return true;
    } catch {
      // Ignore errors and retry
    }

    if ( attempt < maxAttempts - 1 ) {
      await delay( delayMs );
    }
  }

  return false;
}
